import {emptyArray} from '@packages/utilities/fp/utils';

import type {OpaquePanelsState, Pane, PanelName} from './types';
import {unwrap} from './types';
import {first, last} from './utils';

export const getPanels = (state: OpaquePanelsState) => unwrap(state).panels;

export const getParameters = (state: OpaquePanelsState) =>
  unwrap(state).parameters;
export const getPending = (state: OpaquePanelsState) => unwrap(state).pending;

export const getPanelShortcuts = (state: OpaquePanelsState) =>
  getPanels(state).shortcuts;

export const getPanel = (state: OpaquePanelsState, panelName: PanelName) =>
  getPanels(state).all[panelName];

const getPanelPath = (state: OpaquePanelsState, panelName: PanelName) =>
  getPanels(state).paths[panelName];

export const getPanePath = (state: OpaquePanelsState, pane: Pane) => {
  // @ts-expect-error - TS2339 - Property 'panelName' does not exist on type '{ panelName: string | null; isOpen?: boolean | undefined; } | undefined'.
  const {panelName} = unwrap(state).paneState[pane];

  return panelName ? getPanelPath(state, panelName) : emptyArray;
};

export const getActivePath = (state: OpaquePanelsState, pane: Pane) => {
  // @ts-expect-error - TS2339 - Property 'isOpen' does not exist on type '{ panelName: string | null; isOpen?: boolean | undefined; } | undefined'. | TS2339 - Property 'panelName' does not exist on type '{ panelName: string | null; isOpen?: boolean | undefined; } | undefined'.
  const {isOpen, panelName} = unwrap(state).paneState[pane];

  return panelName && (typeof isOpen === 'undefined' || isOpen)
    ? getPanelPath(state, panelName)
    : emptyArray;
};

export const getPaneRoot = (state: OpaquePanelsState, pane: Pane) => {
  const panePath = getPanePath(state, pane);

  return first(panePath) || null;
};

export const getActiveRoot = (state: OpaquePanelsState, pane: Pane) => {
  const activePath = getActivePath(state, pane);

  return first(activePath) || null;
};

export const getActivePanelName = (state: OpaquePanelsState, pane: Pane) => {
  const activePath = getActivePath(state, pane);

  return last(activePath) || null;
};

export const getIsPanelActive = (
  state: OpaquePanelsState,
  panelName: PanelName
) => {
  const activePath = getActivePath(state, 'left');

  // @ts-expect-error - TS18048 - 'activePath' is possibly 'undefined'.
  return activePath.includes(panelName);
};

export const getActiveChild = (
  state: OpaquePanelsState,
  panelName: PanelName
): null | PanelName => {
  const activePath = getActivePath(state, 'left');

  // @ts-expect-error - TS18048 - 'activePath' is possibly 'undefined'. | TS18048 - 'activePath' is possibly 'undefined'.
  if (!activePath.length || !activePath.includes(panelName)) {
    return null;
  }

  const panelPath = getPanelPath(state, panelName);

  // @ts-expect-error - TS18048 - 'activePath' is possibly 'undefined'. | TS18048 - 'panelPath' is possibly 'undefined'.
  return activePath[panelPath.length] || null;
};

export const getAbilityName = (
  state: OpaquePanelsState,
  panelName: PanelName
) => {
  const panel = getPanel(state, panelName);

  return panel && panel.metadata.abilityName;
};

export const getIsTransitionPending = (state: OpaquePanelsState) => {
  return Boolean(state.pending);
};
